import React, { useState } from 'react'
import { Box } from '@mui/material'
import { checkIfProductionEnvironment } from 'src/lib/checkIfProductionEnvironment'
import { advancedColors } from '../theme'
import AdvancedConfigSection from './AdvancedConfigSection'
import AdvancedAdminCareTeams from './AdvancedAdminCareTeams'
import AdvancedAdminMembershipReview from './AdvancedAdminMembershipReview'
import AdvancedAdminFeedback from './AdvancedAdminFeedback'
import AdvancedAdminSettings from './AdvancedAdminSettings'
import AdvancedAdminRoleChats from './AdvancedAdminRoleChats'
import AdvancedTestingGuide from './AdvancedTestingGuide'
import AdvancedTestPatientForm from './AdvancedTestPatientForm'

const AdvancedAdminPanel = () => {
  const [careTeamTableVisible, setCareTeamTableVisible] = useState(false)
  return (
    <Box sx={{ height: '100%', overflowY: 'auto', backgroundColor: advancedColors.canvas, p: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}>
        <AdvancedConfigSection title="Care team configuration" maxWidth={careTeamTableVisible ? 1440 : 960}>
          <AdvancedAdminCareTeams onTableVisibilityChange={setCareTeamTableVisible} />
          <Box sx={{ width: '100%', maxWidth: 960 }}>
            <AdvancedAdminMembershipReview />
          </Box>
        </AdvancedConfigSection>
        <AdvancedConfigSection title="Features">
          <AdvancedAdminRoleChats />
          <AdvancedAdminSettings />
        </AdvancedConfigSection>
        {!checkIfProductionEnvironment() && (
          <AdvancedConfigSection title="WIP & Testing">
            {/* Both read only this browser's localStorage, so a deployed admin would only ever see their own entries. */}
            {process.env.NODE_ENV === 'development' && <AdvancedAdminFeedback />}
            <AdvancedTestPatientForm />
            <AdvancedTestingGuide />
          </AdvancedConfigSection>
        )}
      </Box>
    </Box>
  )
}

export default AdvancedAdminPanel
